import { ModelCommon, UserAttributeDef, UserAttributeDefs, toDatePickerFormat, ValidModelType } from '@iotv/datamodel-core';
import { isValidBusinessObject, MapLike, PathDirection, Position } from '@iotv/iotv-v3-types';

const typeName = 'WaterTake';

export type WaterTakeProps = {
  purposeType?: string;
  meterType?: string;
  diameter?: number;
  maximumFlowRate?: number;
  setFlowRate?: number;
  flow?: number;
  location?: Position;
  pulseCounterFrequency?: number;
  pulseCountCalibration?: number;
  image?: string;
};

export class WaterTake extends ModelCommon {
  constructor(ob: any) {
    super(ob.type || typeName, ob);
  }

  purposeType?: string;
  meterType?: string;
  diameter?: number;
  maximumFlowRate?: number;
  setFlowRate?: number;
  flow?: number;
  location?: Position;
  pulseCounterFrequency?: number;
  pulseCountCalibration?: number;
  image?: string;

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of Water Take' },
      purposeType: { type: 'String', editable: true, label: 'Purpose/ Type', name: 'purpose/Type', description: 'Purpose/ type of Take' },
      meterType: { type: 'String', editable: true, label: 'Meter Type', name: 'meterType', description: 'Meter type' },
      diameter: { type: 'Number', editable: true, label: 'Diameter', name: 'diameter', description: 'Diameter of Water Take pipe mm' },
      maximumFlowRate: {
        type: 'Number',
        editable: true,
        label: 'Maximum Flow Rate',
        name: 'maximumFlowRate',
        description: 'Maximum flow rate in litres/ cubic metres',
      },
      setFlowRate: { type: 'Number', editable: true, label: 'Set Flow Rate', name: 'setFlowRate', description: 'Flow rate set for the Water Take' },
      flow: { type: 'Number', editable: true, label: 'Flow', name: 'flow', description: 'Water flow through the Water Take litres/ sec and cubic metres/ sec' },
      location: { type: 'object', editable: true, label: 'Location', name: 'location', description: 'Location of  Water Take (lat/ long)' },
      pulseCounterFrequency: {
        type: 'Number',
        editable: true,
        label: 'Pulse counter frequency',
        name: 'pulseCounterFrequency',
        description: 'Frequency of pulse counts from meter to measure flow',
      },
      pulseCountCalibration: {
        type: 'Number',
        editable: true,
        label: 'Pulse Count Calibration',
        name: 'pulseCountCalibration',
        description: 'Calibration of pulse counts to calculate water flow',
      },
      image: { type: 'String', editable: true, label: 'Image', name: 'image', description: 'Photograph of Water Take' },
      comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Free text for info ' },
    };
  };
}
